import { call, put, takeLatest } from 'redux-saga/effects'

import { api } from '~/services/api'

import { loginFailed, loginSuccess, LOGIN_START } from '../../actions/auth'
import {
  AUTH_TOKEN,
  REFRESH_TOKEN,
  USER_INFO,
} from '~/common/constants/ApiConstant'
import { NOTIFICATION_DURATION } from '~/common/constants'
import { notification } from 'antd'

/**
 * Login
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const loginApi = (params) => {
  const uri = `/admin/auth/sign-in`
  return api.post(uri, params)
}

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doLogin(action) {
  try {
    const response = yield call(loginApi, action?.payload)
    const { data } = response
    if (!data) {
      notification.error({
        message: 'LOGIN FAILED',
        duration: NOTIFICATION_DURATION,
      })
      return
    }
    // Save token to local storage
    localStorage.setItem(AUTH_TOKEN, data.data.token.access_token)
    // Save refresh token to local storage
    localStorage.setItem(REFRESH_TOKEN, 'REFRESH_TOKEN')
    // Save user infomation to local storage
    localStorage.setItem(USER_INFO, JSON.stringify({ ...data.data.user }))

    yield put(loginSuccess({ ...data.data.user }))

    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess({ ...data.data.user })
    }
  } catch (error) {
    yield put(loginFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * Watch login
 */
export default function* watchLogin() {
  yield takeLatest(LOGIN_START, doLogin)
}
